import * as Utils from "./utils";

const colourSelect = document.querySelector('select[name="variantColour"]'),
    sizeSelect = document.querySelector('select[name="variantSize"]'),
    variantSelect = document.querySelector('select[name="purchasableId"]');

export function productList() {
    htmx.on("htmx:afterSwap", function (event) {
        if (event.target.id === "product-list") {
            // Run any watch transitions
            if (document.querySelector(".js-watch")) {
                Utils.animateInViewEls(".js-watch", "in-view", 0.06);
            }

            if (document.querySelector(".js-watch--opacity")) {
                Utils.animateInViewEls(".js-watch--opacity", "in-view", 0.06);
            }
        }
    });
}

export function product() {
    /**
     * Variant Selections
     */
    // If the colour select exists, add an on change handler to it
    if (colourSelect) {
        colourSelect.addEventListener("change", function (e) {
            updateSelectStatus("colour");
        });
    }

    // If the size select exists, add an on change handler to it
    if (sizeSelect) {
        sizeSelect.addEventListener("change", function (e) {
            updateSelectStatus("size");
        });
    }

    // Disable the colours and sizes that are completely sold out
    disableSoldOutOptions();

    // Scroll to E-Reader Sample
    Utils.scrollToTarget(".js-scroll-to-ereader-sample", 50);
}

export function checkout() {
    const form = document.getElementById("payment-form");
    const stripe = Stripe(form.dataset.stripeKey);

    const stripeElStyles = {
        base: {
            fontSize: "16px",
            fontFamily:
                "Poppins, ui-sans-serif, system-ui -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif",
            color: "#737373",
            "::placeholder": {
                color: "#a3a3a3",
            },
        },
        invalid: {
            color: "#ef4444",
        },
    };

    // Create an instance of Elements
    const elements = stripe.elements();

    // Create an instance of the card Element
    const cardNumber = elements.create("cardNumber", {
            style: stripeElStyles,
            showIcon: true,
        }),
        cardExpiry = elements.create("cardExpiry", {
            style: stripeElStyles,
        }),
        cardCvv = elements.create("cardCvc", {
            style: stripeElStyles,
        });

    // Mount card elements to DOM nodes
    cardNumber.mount(`#paymentForm-stripe-card-number`);
    cardExpiry.mount(`#paymentForm-stripe-card-expiry`);
    cardCvv.mount(`#paymentForm-stripe-card-cvv`);

    // Handle errors
    cardNumber.addEventListener("change", stripeValidation);
    cardExpiry.addEventListener("change", stripeValidation);
    cardCvv.addEventListener("change", stripeValidation);

    form.addEventListener("submit", function (event) {
        event.preventDefault();

        const submitBtn = form.querySelector("button.js-submit"),
            submitBtnText = submitBtn.textContent;

        submitBtn.disabled = true;
        submitBtn.textContent = "Processing...";

        var paymentData = {
            billing_details: {
                email: form.querySelector("[name=orderEmail]").value,
                // name: `${form.querySelector('[name=firstName]').value} ${form.querySelector('[name=lastName]').value}`,
                // phone: form.querySelector('[name=phone]').value,
                // address: {
                //     line1: form.querySelector('[name=addressLine1]').value,
                //     line2: form.querySelector('[name=addressLine2]').value,
                //     city: form.querySelector('[name=city]').value,
                //     postal_code: form.querySelector('[name=postZipCode]').value,
                //     state: form.querySelector('[name=county]').value,
                //     country: form.querySelector('[name=country]').value
                // }
            },
        };

        stripe
            .createPaymentMethod("card", cardNumber, paymentData)
            .then(function (result) {
                if (result.error) {
                    // Show the user any errors
                    var errorElement = document.getElementById(
                        "paymentForm-stripe-card-errors"
                    );
                    errorElement.textContent = result.error.message;

                    submitBtn.disabled = false;
                    submitBtn.textContent = submitBtnText;
                } else {
                    // Insert the token ID into the form so it gets submitted to the server
                    const form = document.getElementById("payment-form"),
                        hiddenInput = document.createElement("input");

                    hiddenInput.setAttribute("type", "hidden");
                    hiddenInput.setAttribute(
                        "name",
                        "paymentForm[stripe][paymentMethodId]"
                    ); // Craft Commerce only needs this
                    hiddenInput.setAttribute("value", result.paymentMethod.id);
                    form.appendChild(hiddenInput);
                    form.submit();
                }
            });
    });
}

function stripeValidation(event) {
    var displayError = document.getElementById(
        "paymentForm-stripe-card-errors"
    );

    if (event.error) {
        displayError.textContent = event.error.message;
    } else {
        displayError.textContent = "";
    }
}

/**
 * Triggered when one of the attribute dropdowns is selected.
 */
function updateSelectStatus(attribute) {
    if (colourSelect && sizeSelect) {
        if (attribute === "colour") {
            disableUnavailableOptions("colour", colourSelect.value);
        } else if (attribute === "size") {
            disableUnavailableOptions("size", sizeSelect.value);
        }

        selectVariant(colourSelect.value, sizeSelect.value);
    } else {
        if (attribute === "colour") {
            selectVariant(colourSelect.value, "");
        } else {
            selectVariant("", sizeSelect.value);
        }
    }
}

/**
 * Selects a variant based on the value of the two attribute dropdowns
 */
function selectVariant(colour, size) {
    let variantOptions = variantSelect.querySelectorAll("option"),
        selectedOption = null;

    variantSelect.value = "";

    variantOptions.forEach((el) => {
        if (
            String(el.dataset.colour) === colour &&
            String(el.dataset.size) === size
        ) {
            variantSelect.value = el.value;
            selectedOption = el;
        }
    });

    updatePrice(selectedOption);
}

/**
 * Based on the attribute and value the user selected, disable all options
 * in the other dropdown that don't have a variant with this value.
 */
function disableUnavailableOptions(attribute, val) {
    var variantOptions = variantSelect.querySelectorAll("option");
    var reverseAttribute = attribute === "colour" ? "size" : "colour";

    if (attribute === "colour") {
        sizeSelect.querySelectorAll("option:disabled").forEach((el) => {
            el.disabled = false;
        });
    } else {
        colourSelect.querySelectorAll("option:disabled").forEach((el) => {
            el.disabled = false;
        });
    }

    if (val !== "") {
        var available = [];

        variantOptions.forEach((el) => {
            if (el.dataset[attribute] === val && !el.disabled) {
                available.push(el.dataset[reverseAttribute]);
            }
        });

        var otherSelect = attribute === "colour" ? sizeSelect : colourSelect;

        otherSelect.querySelectorAll("option").forEach((el) => {
            if (available.includes(el.value) || el.value === "") {
                el.disabled = false;
            } else {
                el.disabled = true;
            }
        });
    }

    disableSoldOutOptions();
}

/**
 * Disables sold out options. Loops over the two selects and checks if
 * there is a variant in the variants dropdown that is not out of stock.
 */
function disableSoldOutOptions() {
    if (!variantSelect) {
        return;
    }

    var variantOptions = variantSelect.querySelectorAll("option");

    if (colourSelect) {
        colourSelect.querySelectorAll("option").forEach((el) => {
            let opt = el,
                found = false;

            variantOptions.forEach((el) => {
                if (
                    el.dataset.outofstock !== true &&
                    String(el.dataset.colour) === opt.value
                ) {
                    found = true;
                }
            });

            if (!found) {
                opt.disabled = true;
            }
        });
    }

    if (sizeSelect) {
        sizeSelect.querySelectorAll("option").forEach((el) => {
            let opt = el,
                found = false;

            variantOptions.forEach((el) => {
                if (
                    el.dataset.outofstock !== true &&
                    String(el.dataset.size) === opt.value
                ) {
                    found = true;
                }
            });

            if (!found) {
                opt.disabled = true;
            }
        });
    }
}

/**
 * Updates the price based on the variant that was selected. You'll probably
 * want to do some currency formatting in here, and maybe remove the sale
 * price if it's the same as the full price.
 */
function updatePrice(option) {
    if (option !== null) {
        const priceFull = document.querySelector("[data-variant-price-full]"),
            priceSale = document.querySelector("[data-variant-price-sale]");

        if (priceFull) {
            priceFull.textContent = option.dataset.price;

            // Only show the original price if it doesn't equal the sale price
            if (option.dataset.price !== option.dataset.saleprice) {
                priceFull.classList.add("show");
            } else {
                priceFull.classList.remove("show");
            }
        }

        if (priceSale) {
            priceSale.textContent = option.dataset.saleprice;
        }
    }
}
